import React from "react";
import { NavLink } from "react-router-dom";
import userIcon from "../../assets/icons/profile.png";
import logout from "../../assets/icons/logout.png";
// import assignedPropIcon from "../../assets/images/icons/assigned-property-menu.png";
import myquotes from "../../assets/icons/myquotes.png";
import document from "../../assets/icons/Documents.png";
// import feedbackIcon from "../../assets/images/icons/reviews-menu.png";
import { useUser } from "../context/UserContext";
import Cookies from "js-cookie";
import myservice from "../../assets/icons/my-service.png";
import { useNavigate } from "react-router-dom";
import ongoing from "../../assets/icons/ongoing.png";
const VendorSideBar = () => {
  const navigate = useNavigate();

  const { setAuthentication } = useUser();
  const handleLogout = () => {
    Cookies.remove("accessToken");
    Cookies.remove("userRole");
    setAuthentication(null);
    navigate("/");
    window.location.reload();
  };
  return (
    <div className="my-account-sidebar">
      <ul className="sidebar-list">
        <li>
          <NavLink to="vendor-profile">
            <img src={userIcon} alt="" />
            My Profile
          </NavLink>
        </li>
        <li>
          <NavLink to="vendor-doument">
            <img src={document} alt="" />
            Business Info
          </NavLink>
        </li>
        <li>
          <NavLink to="vendor-ongoings">
            <img src={myservice} alt="" />
            Ongoings Bookings
          </NavLink>
        </li>
        <li>
          <NavLink to="vendor-comnpleted">
            <img src={ongoing} alt="" />
            Completed Bookings
          </NavLink>
        </li>

        <li>
          <NavLink to="my-quotes">
            <img src={myquotes} alt="" />
            My Quotes
          </NavLink>
        </li>
        <li>
          <NavLink to="/" onClick={handleLogout}>
            <img src={logout} alt="" /> Logout
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default VendorSideBar;
